'use client'

import { createContext, Dispatch, SetStateAction, useContext, useState } from 'react'

interface ProtocolContext {
  protocol: string
  setProtocol: Dispatch<SetStateAction<string>>
}

const ProtocolContext = createContext<ProtocolContext>({
  protocol: '',
  setProtocol: () => '',
})

export const ProtocolContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [protocol, setProtocol] = useState('')

  return (
    <ProtocolContext.Provider value={{ protocol, setProtocol }}>
      {children}
    </ProtocolContext.Provider>
  )
}

export const useProtocolContext = () => useContext(ProtocolContext)
